import React, { Component, createRef, Fragment } from "react";
import { CONNECTOR, DIODE, LOAD, PMIC, ROOT } from "../../../../constants/componentType";
import { getTextWidthAndHeight } from "../../../../services/helper/getTextWidth";
import { Input, message, Tooltip } from "antd";
import { splitArrayToArrays } from "../../../../services/helper/arrayHelper";
import { numberCheck } from "../../../../services/helper/dataProcess";
import IconCollection from "../../../../components/TreeIconCollection";
import EditPanel from "./edit";
import { CONN_PREFIX } from "../../../../services/Cascade/PowerTree/v2/constants";
import treeResults from "../../../../services/Cascade/PowerTree/v2/results";
import { unitChange } from "../../../../services/helper/mathHelper";
import { FileTextOutlined } from '@ant-design/icons';
import _ from 'lodash';

const LEFT = 'left', RIGHT = 'right', GND = 'gnd';
class TreeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      top: 0,
      left: 0,
      padding: "0px, 0px, 0px, 0px",
      fontSize: 20,
      inputStatus: {},
      editVisible: false,
      pinDoms: [],
      resultStatus: undefined
    }
    this.inputRef = createRef();
  }

  componentDidMount() {
    this.getItemPosition();
    this.getPinPosition();
    this.setResultState();
  }

  componentDidUpdate = (prevProps) => {
    const { gridWidth, gridHeight, posUpdate, resultStatus } = this.props;
    if (gridWidth !== prevProps.gridWidth || gridHeight !== prevProps.gridHeight || posUpdate) {
      this.getItemPosition();
      this.props.updatePosition(false);
      this.getPinPosition();
    }
    if (prevProps.resultStatus !== resultStatus) {
      this.setResultState()
    }
  }

  setResultState = () => {
    const { resultStatus } = this.props;
    this.setState({
      resultStatus: resultStatus
    })
  }

  toInput = (e, type) => {
    e && e.stopPropagation();
    this.setState({
      inputStatus: {
        ...this.state.inputStatus,
        [type]: true
      }
    }, () => {
      this.inputRef && this.inputRef.current && this.inputRef.current.focus();
    })
  }

  saveValue = (e, prevValue, type) => {
    const { data, columnIndex } = this.props;
    e && e.stopPropagation();
    let value = e.target.value;
    if (prevValue !== value) {
      let errorCheck = null;
      if (value) {
        errorCheck = numberCheck(value)
      }
      if (errorCheck) {
        message.error(`${data.name} - ${errorCheck}`);
      } else {
        this.props.saveTreeItemValue(value, type, data.id, columnIndex);
      }
    }
    this.setState({
      inputStatus: {
        ...this.state.inputStatus,
        [type]: false
      }
    })
  }

  saveConnectorValue = (e, prevValue, type, net) => {
    const { data, columnIndex } = this.props;
    e && e.stopPropagation();
    let value = e.target.value;
    if (prevValue !== value) {
      let errorCheck = null;
      if (value) {
        errorCheck = numberCheck(value)
      }
      if (errorCheck) {
        message.error(`${data.name} - ${errorCheck}`);
      } else {
        this.props.saveConnectorTreeItemValue(value, net, data.id, columnIndex);
      }
    }
    this.setState({
      inputStatus: {
        ...this.state.inputStatus,
        [type]: false
      }
    })
  }

  deleteTreeItem = (e) => {
    const { data } = this.props;
    e && e.stopPropagation();
    const { id } = data;
    this.props.deleteTreeItem(id);
  }

  displayItem = (e) => {
    const { data } = this.props;
    e && e.stopPropagation();
    const { id } = data;
    this.props.showTreeAction(id, false);
  }

  displayItemPath = (e) => {
    const { data } = this.props;
    e && e.stopPropagation();
    const { id } = data;
    this.props.showTreeAction(id, true);
  }

  getItemPosition = () => {
    const { data, columnIndex, gridWidth, gridHeight } = this.props;
    let top = 0, left = 0;
    if (data.type === ROOT) {
      top = 0;
      left = 0;
    } else {
      left = gridWidth * columnIndex;
      const deepIndex = data.deep;
      top = deepIndex ? (deepIndex - 1) * gridHeight : -1;
    }
    this.setState({
      top,
      left,
      padding: `${gridHeight * 0.2}px ${gridWidth * 0.2}px ${gridHeight * 0.2}px ${gridWidth * 0.2}px`,
      fontSize: Math.floor(gridWidth / 12) - 5 > 3 ? Math.floor(gridWidth / 12) - 5 : 3
    })
  }

  getPinPosition = () => {
    const { data, gridHeight } = this.props;
    const { next, prev, type, number } = data;
    const pinDoms = []
    if (prev && prev.length) {
      if (!number) {
        pinDoms.push({ type: LEFT, nets: prev.map(p => p.prevNet).filter(net => !net.includes(CONN_PREFIX)), style: { top: 0.25 * gridHeight } })
      } else {
        for (let i = 0; i < prev.length; i++) {
          const { prevNet } = prev[i];
          if (prevNet.includes(CONN_PREFIX)) {
            continue;
          }
          const top = (i + 0.25) * gridHeight;
          pinDoms.push({ type: LEFT, nets: [prevNet], style: { top } })
        }
      }
    }
    if (next && next.length) {
      const { trueArray: gnd, falseArray: power } = splitArrayToArrays({ array: next, rule: (item) => item.isGnd && [PMIC, ROOT].includes(type) });
      if (!number) {
        pinDoms.push({ type: RIGHT, nets: power.map(p => p.nextNet).filter(net => !net.includes(CONN_PREFIX)), style: { top: 0.25 * gridHeight } })
      } else {
        for (let i = 0; i < power.length; i++) {
          const { nextNet } = power[i];
          if (nextNet.includes(CONN_PREFIX)) {
            continue;
          }
          const top = (i + 0.25) * gridHeight;
          pinDoms.push({ type: RIGHT, nets: [nextNet], style: { top } })
        }
      }
      if (gnd && gnd.length) {
        pinDoms.push({ type: GND, nets: gnd.map(p => p.nextNet).filter(net => !net.includes(CONN_PREFIX)), style: {} })
      }
    }
    this.setState({
      pinDoms
    })
  }

  getPinDetails = (pins, type) => {
    let detailList = [];
    if (type === "left") {
      detailList = [...new Set(pins.map(pin => `${pin.net} --> ${pin.comp ? `(${pin.comp})` : ''}[${pin.pinName}::${pin.pin}]`))];
    } else {
      detailList = [...new Set(pins.map(pin => `${pin.comp ? `(${pin.comp})` : ''}[${pin.pinName}::${pin.pin}] --> ${pin.net}`))];
    }
    const detail = detailList && detailList.length ? <div className="cascade-display-detail-box">
      {detailList.map((detail, index) => <div key={index}>{detail}</div>)}
    </div> : null
    return detail
  }

  display = () => {
    const { setting, data } = this.props;
    const { type } = data;
    return type === ROOT || type === PMIC ? true : setting[`display${type}`];
  }

  editTreeComponent = (newData) => {
    const { data } = this.props;
    const { id } = data;
    this.closeEditPanel()
    this.props.editTreeItem(id, newData)
  }

  openEditPanel = () => {
    this.setState({
      editVisible: true
    })
  }

  closeEditPanel = () => {
    this.setState({
      editVisible: false
    })
  }

  setAsConnector = () => {
    const { data } = this.props;
    const { pcbKey, name } = data;
    this.props.setTreeItemAsConnector(name, pcbKey)
  }

  judgeUnitChange = (num, decimals = 2) => {
    if (num < 10) {
      const newNum = unitChange({ num, oldUnit: 'Ω', newUnit: 'mΩ', decimals }).number;
      return { number: String(newNum), unit: 'mΩ' }
    } else {
      return { number: String(num), unit: 'Ω' }
    }
  }

  resultDetail = (passResultData, data, pass, notSet) => {
    const { realVMin } = passResultData;
    const { vMin } = data;
    const spanStyle = notSet ? { color: '#393939' } : pass ? { color: '#00a913' } : { color: '#f5222d' }
    const showMin = Number(realVMin).toPrecision(3).length > 5 ? Number(Number(realVMin).toPrecision(3)).toExponential() : Number(realVMin).toPrecision(3);
    return <div className="cascade-display-detail-box">
      <div>Status: <span style={spanStyle}>{notSet ? 'Not set spec.' : pass ? 'Pass' : 'Failed'}</span></div>
      <div>Vmin: <span style={notSet ? {} : realVMin && Number(vMin) > Number(realVMin) ? { color: '#f5222d' } : {}}>
        {realVMin ? showMin : 'Not Found'}
      </span></div>
    </div>
  }

  pairDetail = (pairData, ifPairRes) => {
    const { data: { name } } = this.props;
    const prevComps = [...new Set(pairData.map(item => item.componentOut))];
    let details = []
    for (let prevComp of prevComps) {
      const pairs = pairData.filter(pair => pair.componentOut === prevComp);
      details.push(<div className="font-bold" key={`${prevComp} - ${name}`}>{prevComp} - {name}</div>)
      if (pairs.length > 1) {
        const max = this.judgeUnitChange(Math.max(...pairs.map(item => Number(item.res))), 5)
        const resistances = pairs.map(current => current.res === 'inf' ? Infinity : Number(current.res));
        const avg = this.judgeUnitChange(_.mean(resistances), 5)
        const min = this.judgeUnitChange(Math.min(...pairs.map(item => Number(item.res))), 5)
        details.push(<Fragment key={prevComp}>
          <div>&nbsp;&nbsp;Max: {max.number}{max.unit}</div>
          <div>&nbsp;&nbsp;Avg: {avg.number}{avg.unit}</div>
          <div>&nbsp;&nbsp;Min: {min.number}{min.unit}</div>
        </Fragment>)
      } else if (pairs.length === 1) {
        const { number, unit } = this.judgeUnitChange(Number(pairs[0].res), 5)
        details.push(<div key={prevComp}>&nbsp;&nbsp;Avg: {number}{unit}</div>)
      }
    }
    if (ifPairRes) {
      const { number, unit } = this.judgeUnitChange(ifPairRes.ifValue, 5)
      details.push(<Fragment key='what-if-res'>
        <div className="font-bold">Offline IR Drop Calculation:</div>
        <div>&nbsp;&nbsp;Avg: {number}{unit}</div>
      </Fragment>)
    }
    return <div className="cascade-display-detail-box">{details}</div>
  }

  voltageDetail = (vol, spVol) => {
    return <div className="cascade-display-detail-box">
      <span>Voltage: {vol.toFixed(8)}V</span>
      <br />
      {spVol ? <span>Voltage (Offline IR Drop Calculation): {spVol.toFixed(8)}V</span> : null}
    </div>
  }

  changeWhatIfValue = (e, pairRes, type, unit) => {
    const whatIfValue = e.target.value;
    const { data: { pcbKey } } = this.props;
    this.setState({
      inputStatus: {
        ...this.state.inputStatus,
        [type]: false
      }
    })
    if (pairRes[0]) {
      const { number } = unitChange({ num: whatIfValue, oldUnit: unit, newUnit: 'Ω' });
      this.props.saveWhatIfData(pairRes[0], number, pcbKey);
    }
  }

  getCompContent(type, name, number) {
    const { gridHeight, data, setting: { valueDisplay = true, autoSize, nameSize } } = this.props;
    const { isGnd } = data;
    const { fontSize } = this.state;
    const { height } = getTextWidthAndHeight(name, { fontSize: autoSize ? fontSize : nameSize })
    let compContent = {};
    switch (type) {
      case ROOT:
        compContent = { color: '#f47188', render: this.rootRender, style: {} };
        break;
      case LOAD:
        compContent = { color: '#6495ed', render: !isGnd ? this.loadRender : null, style: isGnd ? { marginTop: 0.28 * gridHeight - 0.5 * height } : {} };
        break;
      case PMIC:
        compContent = { color: '#f47188', render: !isGnd ? this.pmicRender : null, style: isGnd ? { marginTop: 0.28 * gridHeight - 0.5 * height } : {} };
        break;
      case DIODE:
        compContent = { color: '#f4b183', render: null, style: { marginTop: 0.28 * gridHeight - 0.5 * height } };
        break;
      case CONNECTOR:
        compContent = { color: '#9998ff', render: this.connectorResRender, style: number > 1 ? { marginTop: ((number - 0.4) / 2) * gridHeight - 0.5 * height - (number % 2 !== 0 ? 30 : 0) } : {} };
        break;
      default:
        compContent = { color: '#f4b183', render: this.resistanceRender, style: {} };
        break;
    }
    if (!valueDisplay) {
      compContent.render = null;
      compContent.style = [CONNECTOR].includes(type) ? { marginTop: ((number - 0.4) / 2) * gridHeight - 0.5 * height } : { marginTop: 0.28 * gridHeight - 0.5 * height };
    }
    return compContent
  }

  pinRender = () => {
    const { data } = this.props;
    const { pins, broComp, name } = data;
    const { pinDoms } = this.state;
    return pinDoms.map((pinDom, index) => {
      const { type, nets, style } = pinDom;
      const _pins = broComp ? [...broComp.pins.map(pin => ({ ...pin, comp: broComp.name })), ...pins.map(pin => ({ ...pin, comp: name }))].filter(pin => nets.includes(pin.net)) : pins.filter(pin => nets.includes(pin.net));
      const detail = this.getPinDetails(_pins, type)
      return type === GND ? this.pinGndRender(index, detail, style) : this.pinDomRender(index, type, detail, style)
    })
  }

  pinDomRender = (index, type, detail, style = {}) => {
    return <div key={index}>
      <Tooltip
        classNames={{ root: "aurora-tooltip cascade-detail-tooltip" }}
        title={detail}
        placement={type === LEFT ? "topRight" : "topLeft"}
      >
        <div className={`tree-pin tree-pin-${type}`} style={style}></div>
      </Tooltip>
    </div>
  }

  pinGndRender = (index, detail, style = {}) => {
    return <div key={index}>
      <Tooltip
        classNames={{ root: "aurora-tooltip cascade-detail-tooltip" }}
        title={detail}
        placement={"top"}
      >
        <div className={`tree-pin-gnd`} style={style}></div>
      </Tooltip>
    </div>
  }

  resistanceRender = (key = 'resistance') => {
    const { gridHeight, data, setting: { autoSize, nameSize } } = this.props;
    const { fontSize } = this.state;
    const resistance = data[key]
    const _fontSize = autoSize ? fontSize : nameSize
    const style = { top: 0.2 * gridHeight }
    const sub = key === 'resistance' ? '' : <sub>gnd</sub>
    return <div className={`tree-component-value comp-value tree-component-value-v2`} style={{ ...style }} title={`R=${resistance ? resistance : `__`}mΩ`}>
      <span className="cascade-power-tree-value-title">R{sub}=</span>
      {this.inputRender(resistance, key, _fontSize)}
      <span className="cascade-power-tree-value-title">mΩ</span>
    </div>
  }

  connectorResRender = () => {
    const { data } = this.props;
    const { resistances = [] } = data;
    const { pinDoms } = this.state;
    return resistances.map(resItem => {
      const { isGnd, resistance, net } = resItem
      const pinDom = pinDoms.find(dom => dom.nets.includes(net));
      if (pinDom) {
        const { style: { top } } = pinDom;
        return this.connectorResistanceRender(isGnd ? 'gndResistance' : 'resistance', top - 7, resistance, net);
      }
      return null;
    });
  }

  connectorResistanceRender = (key = 'resistance', top, resistance, net) => {
    const { setting: { autoSize, nameSize } } = this.props;
    const { fontSize } = this.state;
    const _fontSize = autoSize ? fontSize : nameSize
    const style = { top }
    const sub = key === 'resistance' ? '' : <sub>gnd</sub>
    return <div key={net} className={`tree-component-value comp-value tree-component-value-v2`} style={{ ...style }} title={`R=${resistance ? resistance : `__`}mΩ`}>
      <span className="cascade-power-tree-value-title">R{sub}=</span>
      {this.inputRender(resistance, key, _fontSize, { componentType: CONNECTOR, net })}
      <span className="cascade-power-tree-value-title">mΩ</span>
    </div>
  }

  rootRender = (i = 0) => {
    const { gridHeight, data, setting: { autoSize, nameSize } } = this.props;
    const { fontSize } = this.state;
    const { voltage } = data
    const _fontSize = autoSize ? fontSize : nameSize
    const style = { top: (i + 0.2) * gridHeight }
    return <div className={`tree-component-value comp-value tree-component-value-v2`} style={{ ...style }} title={`${voltage ? voltage : `__`}V`}>
      {this.inputRender(voltage, 'voltage', _fontSize)}
      <span className="cascade-power-tree-value-title">V</span>
    </div>
  }

  pmicRender = (i = 0) => {
    const { gridHeight, data, setting: { autoSize, nameSize } } = this.props;
    const { fontSize } = this.state;
    const { voltage, load, vMin } = data
    const _fontSize = autoSize ? fontSize : nameSize
    const style = { top: (i + 0.2) * gridHeight }
    return <Fragment>
      <div className={`tree-component-value comp-value tree-component-value-v2`} style={{ top: style.top - 10 }} title={`${voltage ? voltage : `__`}V/${load ? load : `__`}mA`}>
        {this.inputRender(voltage, 'voltage', _fontSize)}
        <span className="cascade-power-tree-value-title">V/</span>
        {this.inputRender(load, 'load', _fontSize)}
        <span className="cascade-power-tree-value-title">mA</span>
      </div>
      <div className={`tree-component-value comp-value tree-component-value-v2`} style={{ top: style.top + 12 }} title={`${vMin ? vMin : `__`}`}>
        <span className="cascade-power-tree-value-title">Vmin=</span>
        {this.inputRender(vMin, 'vMin', _fontSize)}
      </div>
    </Fragment>
  }

  loadRender = (i = 0) => {
    const { gridHeight, data, setting: { autoSize, nameSize } } = this.props;
    const { fontSize } = this.state;
    const { load, vMin } = data
    const _fontSize = autoSize ? fontSize : nameSize
    const style = { top: (i + 0.2) * gridHeight }
    return <Fragment>
      <div className={`tree-component-value comp-value tree-component-value-v2`} style={{ top: style.top - 10 }} title={`I=${load ? load : `__`}mA`}>
        <span className="cascade-power-tree-value-title">I=</span>
        {this.inputRender(load, 'load', _fontSize)}
        <span className="cascade-power-tree-value-title">mA</span>
      </div>
      <div className={`tree-component-value comp-value tree-component-value-v2`} style={{ top: style.top + 12 }} title={`${vMin ? vMin : `__`}`}>
        <span className="cascade-power-tree-value-title">Vmin=</span>
        {this.inputRender(vMin, 'vMin', _fontSize)}
      </div>
    </Fragment>
  }

  inputRender = (value, type, fontSize, props = {}) => {
    const { inputStatus } = this.state;
    const { disabled = false, componentType, net } = props;
    let style = value ? {} : { borderBottom: '1px solid black', height: `${fontSize}px`, lineHeight: `${fontSize}px` };
    style.cursor = disabled ? 'not-allowed' : 'pointer';
    const valueType = componentType === CONNECTOR ? `${type}-${net}` : type;
    return inputStatus[valueType] ?
      <Input
        className="component-input"
        defaultValue={value}
        onBlur={(e) => componentType === CONNECTOR ? this.saveConnectorValue(e, value, valueType, net) : this.saveValue(e, value, valueType)}
        onPressEnter={(e) => componentType === CONNECTOR ? this.saveConnectorValue(e, value, valueType, net) : this.saveValue(e, value, valueType)}
        ref={this.inputRef}
      />
      : <span
        className="component-span cascade-power-tree-value-title"
        style={style}
        onClick={(e) => disabled ? null : this.toInput(e, valueType)}
      >{value}</span>
  }

  iconRender = () => {
    const { designId, columnIndex, showLayout, running, data } = this.props;
    const { fontSize } = this.state;
    const _fontSize = fontSize > 14 ? 12 : fontSize < 10 ? 8 : fontSize - 2;
    const fontSizePx = `${_fontSize}px`;
    const menu = [{ title: 'Edit', icon: 'edit', disabled: !designId ? true : running ? true : false, func: this.openEditPanel }];
    if (data && data.type === LOAD) {
      menu.push({ title: 'Set as Connector', icon: 'connect', func: this.setAsConnector })
    }
    const basicMenu = [
      { title: 'Display', icon: 'eye', disabled: !showLayout, func: this.displayItem },
      { title: 'Show Path', icon: 'eye', disabled: !showLayout, func: this.displayItemPath },
      { title: 'Delete', icon: 'close', func: this.deleteTreeItem, disabled: running ? true : columnIndex === 0 ? true : false, tooltip: columnIndex === 0 ? 'Root component can not be delete.' : '' }
    ]
    return (
      <div className="tree-icon-box" style={{ height: fontSizePx, lineHeight: fontSizePx }} >
        <IconCollection menu={[...menu, ...basicMenu]} className="power-tree-icon-collection" />
      </div>
    );
  }

  resultRender = () => {
    const { data, treeId, showResult = {}, whatIf } = this.props;
    const { id, isGnd } = data;
    const result = treeResults.getTreeResult(treeId, id);
    if (!result) {
      return null;
    }
    const spiceResult = whatIf ? treeResults.getSpiceResult(treeId, id) || {} : {};
    const { voltage: spiceVoltage = [], totalRes: spiceTotalRes } = spiceResult;
    const displayRenders = [];
    const { pass, pairRes, voltage, totalRes } = result;
    if (pass && showResult.pass && !isGnd) {
      displayRenders.push(this.passRender(pass))
    }
    if (pairRes || voltage) {
      displayRenders.push(this.pairAndVolRender(pairRes, voltage, { spiceVoltage }))
    }
    if (pass || totalRes) {
      displayRenders.push(this.topResultRender(pass, totalRes, isGnd, { spiceTotalRes }));
    }
    return displayRenders.map(render => render)
  }

  passRender = (passData) => {
    const { realVMin } = passData;
    const { data, setting: { autoSize, passSize } } = this.props;
    const { vMin, vMax } = data;
    const notSet = vMin || vMax ? false : true
    const pass = notSet ? false : realVMin && vMin ? Number(realVMin) > Number(vMin) ? true : false : false
    const spanStyle = notSet ? { color: '#c9c9c9' } : pass ? { color: '#00f61c' } : { color: '#f5222d' }
    return <div key="pass" className='tree-result-box' style={autoSize ? {} : { fontSize: Number(passSize) }}>
      <Tooltip classNames={{ root: "aurora-tooltip cascade-detail-tooltip" }} title={this.resultDetail(passData, data, pass, notSet)}>
        <span style={{ fontWeight: 'bold', cursor: 'pointer', ...spanStyle }}>{notSet ? 'N' : pass ? 'P' : 'F'}</span>
      </Tooltip>
    </div>
  }

  topResultRender = (passData, totalRes, isGnd, whatIfData = {}) => {
    const { setting: { autoSize, passSize, pairResSize }, gridWidth, showResult, whatIf, data } = this.props;
    const { spiceTotalRes } = whatIfData;
    const { deep } = data;
    let results = [], top = -5, width = gridWidth * 0.6, resultsInLine = '', left = 0;
    if (passData && showResult.pass && !isGnd) {
      const { realVMin } = passData;
      const showMin = realVMin ? Number(realVMin).toPrecision(3).length > 5 ? Number(Number(realVMin).toPrecision(3)).toExponential() : Number(realVMin).toPrecision(3) : null;
      const text = `Vmin: ${realVMin ? showMin : 'Not Found'}`;
      const _fontSize = autoSize ? 12 : Number(passSize)
      const { height } = getTextWidthAndHeight(text, { fontSize: _fontSize })
      top = top - height;
      results.push(deep === 1 ? <span key={'pass-top'} style={{ fontSize: _fontSize }}>{text}</span> : <div key={'pass-top'} style={{ fontSize: _fontSize }}>{text}</div>)
      resultsInLine = `${text}`;
    }
    if (totalRes && showResult.pairRes) {
      const tRes = whatIf && spiceTotalRes ? spiceTotalRes.totalValue || '' : totalRes.totalValue || '';
      if (tRes) {
        const _fontSize = autoSize ? 12 : Number(pairResSize);
        const { number, unit } = this.judgeUnitChange(tRes);
        const text = `Total Res: ${number}${unit}`
        const { height } = getTextWidthAndHeight(text, { fontSize: _fontSize });
        const whatIfClass = whatIf ? spiceTotalRes && totalRes ? spiceTotalRes.totalValue > totalRes.totalValue ? 'cascade-power-tree-experiment-up-modify' : 'cascade-power-tree-experiment-down-modify' : 'cascade-power-tree-experiment-not-modify' : ''
        top = deep === 1 ? top : top - height;
        results.push(deep === 1 ? <span key={'total-res-top'} className={whatIfClass} style={{ fontSize: _fontSize }}>{resultsInLine ? '/' : ''}{text}</span> : <div key={'total-res-top'} className={whatIfClass} style={{ fontSize: _fontSize }}>{text}</div>)
        resultsInLine = resultsInLine ? `${resultsInLine}/${text}` : text;
      }
    }
    if (deep === 1) {
      const _fontSize = autoSize ? 12 : Number(passSize)
      const { width: textWidth, height } = getTextWidthAndHeight(resultsInLine, _fontSize);
      const compWidth = gridWidth * 0.6;
      width = compWidth > textWidth + 5 ? compWidth : textWidth + 5;
      left = textWidth - compWidth > 0 ? -((textWidth - compWidth) / 2) : 0
      top = -5 - height;
    }
    return <div key="topResult" className='tree-result-top-box' style={{ top, width, left }}>
      {results}
    </div>
  }

  pairAndVolRender = (pairRes = [], voltage, whatIfRes = {}) => {
    const { pinDoms, fontSize, inputStatus } = this.state;
    const { data, showResult, setting: { autoSize, pairResSize, voltageSize }, whatIf, whatIfData } = this.props;
    const { pins, pcbKey, name } = data;
    const _fontSize = autoSize ? fontSize > 8 ? fontSize > 12 ? 12 : fontSize : 8 : Number(pairResSize)
    const volFontSize = autoSize ? 10 : Number(voltageSize)
    return pinDoms.map(pin => {
      const { style: { top }, nets, type } = pin;
      if (type === GND) {
        return null;
      }
      let results = [];
      if (showResult.pairRes) {
        const _pins = pins.filter(pin => nets.includes(pin.net));
        const _pairRes = pairRes.filter(item => _pins.some(pin => pin.pin === item.pinIn));
        const ifPairRes = whatIf ? whatIfData.find(d => d.pcbKey === pcbKey && d.componentIn === name && _pins.some(pin => pin.pin === d.pinIn)) : undefined;
        if (_pairRes.length) {
          const resistances = _pairRes.map(current => current.res === 'inf' ? Infinity : Number(current.res));
          const resistance = _.mean(resistances), ifNumber = ifPairRes ? Number(ifPairRes.ifValue) : -Infinity;
          const res = ifPairRes ? ifNumber : resistance;
          const whatIfClass = whatIf ? resistance && ifPairRes ? ifNumber > resistance ? 'cascade-power-tree-experiment-up-modify' : 'cascade-power-tree-experiment-down-modify' : 'cascade-power-tree-experiment-not-modify' : ''
          const { number, unit } = this.judgeUnitChange(res)
          const { width: resWidth, height: resHeight } = getTextWidthAndHeight(`${number}${unit}`, { fontSize: _fontSize, fontWeight: 'bold' });
          results.push(
            <div className={`tree-result-pair-box ${whatIfClass}`} key="pair" style={{ fontWeight: 'bold', fontSize: _fontSize, top: top - resHeight - 5, left: 0 - resWidth - (_pairRes.length > 1 ? 30 : 15) }}>
              {
                inputStatus[`whatIf-${nets.join('-')}`] ? <Input
                  className="component-input cascade-power-tree-what-if-input"
                  defaultValue={ifPairRes ? number : ''}
                  onBlur={(e) => this.changeWhatIfValue(e, _pairRes, `whatIf-${nets.join('-')}`, unit)}
                  onPressEnter={(e) => this.changeWhatIfValue(e, _pairRes, `whatIf-${nets.join('-')}`, unit)}
                  addonAfter={unit}
                  ref={this.inputRef}
                /> :
                  <Tooltip classNames={{ root: "aurora-tooltip cascade-detail-tooltip" }} title={this.pairDetail(_pairRes, ifPairRes)}>
                    <span className={_pairRes.length > 1 ? '' : 'cursor-pointer'} onClick={(e) => _pairRes.length > 1 ? null : this.toInput(e, `whatIf-${nets.join('-')}`)}>{_pairRes.length > 1 ? <FileTextOutlined /> : null}{number}{unit}</span>
                  </Tooltip>
              }
            </div>
          )
        }
      }
      if (showResult.voltage) {
        const voltages = voltage.filter(item => nets.includes(item.net));
        const { spiceVoltage = [] } = whatIfRes;
        const spiceVoltages = spiceVoltage.filter(item => nets.includes(item.net))
        if (voltages.length) {
          const vol = _.mean(voltages.map(current => current.voltage === 'inf' ? Infinity : Number(current.voltage)));
          const spVol = whatIf && spiceVoltages.length ? _.mean(spiceVoltages.map(current => current.voltage === 'inf' ? Infinity : Number(current.voltage))) : null;
          const volText = whatIf && spiceVoltages.length ? spVol.toPrecision(4).length > 5 ? Number(spVol.toPrecision(3)).toExponential() : spVol.toPrecision(4)
            : vol.toPrecision(4).length > 5 ? Number(vol.toPrecision(3)).toExponential() : vol.toPrecision(4);
          const { height: resHeight } = getTextWidthAndHeight(`${volText}V`, { fontSize: volFontSize });
          const position = type === LEFT ? { left: 3 } : { right: 3 }
          const whatIfClass = whatIf && spiceVoltages.length ? 'cascade-power-tree-experiment-voltage' : ''
          results.push(
            <div className={`tree-result-voltage-box ${whatIfClass}`} key="voltage" style={{ fontSize: volFontSize, top: top - resHeight - 2, ...position }}>
              <Tooltip classNames={{ root: "aurora-tooltip cascade-detail-tooltip" }} title={this.voltageDetail(vol, spVol)}>
                <span>{volText}V</span>
              </Tooltip>
            </div>
          )
        }
      }
      return <div key={nets}>
        {results}
      </div>
    })
  }

  render() {
    const { gridWidth, gridHeight, data, selectkey, setting, pcbName, designId, columnIndex } = this.props;
    const { top, left, padding, fontSize, editVisible } = this.state;
    const { type, name, broComp, number = 1, pcbKey, id } = data;
    const content = this.getCompContent(type, name, number);
    const style = { width: gridWidth, height: gridHeight * number, top, left, padding };
    const { autoSize = true, nameSize } = setting
    return top > -1 ? <Fragment key={id}>
      {this.display() && <div className={`${pcbKey && selectkey === pcbKey ? 'cascade-power-tree-canvas-select-pcb-component' : ''} cascade-power-tree-canvas-component`} style={style}>
        <div className="tree-component-content" style={{ backgroundColor: content.color }} onMouseEnter={this.mouseEnterHandle} onMouseLeave={this.mouseLeaveHandle}>
          <div className="tree-component-name" style={{ fontSize: autoSize ? fontSize : Number(nameSize), ...content.style }}>{`${name}${broComp ? ` - ${broComp.name}` : ''}`}</div>
          {content.render ? content.render() : null}
          {this.pinRender()}
          {this.iconRender()}
          {this.resultRender()}
          {pcbName && <span className="tree-component-pcb-name" style={{ top: 0 - 0.2 * gridHeight, left: - 0.2 * gridWidth }}>{pcbName}</span>}
        </div>
      </div>}
      {
        editVisible && <EditPanel
          name={name}
          data={data}
          type={type}
          designId={designId}
          columnIndex={columnIndex}
          closePanel={this.closeEditPanel}
          traceByComponent={this.props.traceByComponent}
          editTreeComponent={this.editTreeComponent}
          checkDeep={this.props.checkDeep}
        />
      }
    </Fragment> : null
  }
}

export default TreeComponent